import { render, staticRenderFns } from "./UserPortalManager.vue?vue&type=template&id=d33174d8&scoped=true&"
import script from "./UserPortalManager.vue?vue&type=script&lang=js&"
export * from "./UserPortalManager.vue?vue&type=script&lang=js&"
import style0 from "./UserPortalManager.vue?vue&type=style&index=0&id=d33174d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33174d8",
  null
  
)

export default component.exports